const isLocalhost = () => {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]' || hostname.includes('netlify');
};
export const LoggingService = {
    Log(content: any) {
        if (isLocalhost()) {
            console.log(content);
        }
    }
};
